"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _actions = require("../../actions");

var _styled = require("./styled");

var _notification = _interopRequireDefault(require("./notification"));

var _uniqueId = _interopRequireDefault(require("./utils/uniqueId"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var AppNotificationManager = function AppNotificationManager() {
  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      notifications = _useState2[0],
      setNotifications = _useState2[1];

  var removeNotification = function removeNotification(key) {
    setNotifications(function (notifications) {
      return notifications.filter(function (item) {
        return item.key !== key;
      });
    });
  };

  var addNotification = function addNotification(notification) {
    var key = (0, _uniqueId["default"])('notification');
    setNotifications(function (notifications) {
      return [_objectSpread({
        key: key
      }, notification)].concat((0, _toConsumableArray2["default"])(notifications));
    });
  };

  (0, _react.useEffect)(function () {
    (0, _actions.updateAppActions)({
      addNotification: addNotification
    });
  }, []);
  var children = notifications.map(function (n) {
    var key = n.key,
        title = n.title,
        description = n.description,
        icon = n.icon,
        timeout = n.timeout;
    return /*#__PURE__*/_react["default"].createElement(_notification["default"], {
      key: key,
      title: title,
      description: description,
      icon: icon,
      onRequestClose: function onRequestClose() {
        return removeNotification(key);
      },
      timeout: timeout
    });
  });
  return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(_styled.StyledNotificationContainer, null, children), document.body);
};

AppNotificationManager.propTypes = {};
var _default = AppNotificationManager;
exports["default"] = _default;